<div class="pr" style="display: flex; flex-direction: row; gap: 15px;">
    <div *ngIf="title">
      <i class="pi pi-chevron-down clickable" style="font-size: 14px;" *ngIf="!expanded" (click)="expanded = !expanded; onExpandedChange()"></i>
      <i class="pi pi-chevron-up clickable" style="font-size: 14px;" *ngIf="expanded" (click)="expanded = !expanded; onExpandedChange()"></i>
    </div>
    <div style="flex: 1;">
      <div class="block bold" style="font-size: 18px;" *ngIf="title">{{title}}</div>
      <div class="block bold" style="font-size: 14px;" *ngIf="subTitle">{{subTitle}}</div>
      <div class="dblock" style="display: flex; flex-direction: row; gap: 10px;" *ngIf="expanded && categoryTargetPercent && categoryTargetPercent.length > 0">
          <div *ngIf="config?.chartStyle == 'BAR_CHART'" style="border: 1px solid #CCC; width: 100%; padding: 20px;">
              <div class="dblock bold">Target Allocations</div>
              <div style="width: 700px;">
                <p-chart type="bar" [data]="chartDataBar" [options]="barChartOptions" [plugins]="plugins" [height]="barChartHeight"></p-chart>
              </div>
          </div>
          <div *ngIf="config?.chartStyle == 'PIE_CHART'" style="border: 1px solid #CCC; width: 100%; padding: 20px 20px 20px 40px;">
              <div class="dblock bold">Target Allocations</div>
              <div style="display: flex; flex-direction: row; gap: 60px; align-items: flex-start;">
                  <p-chart type="doughnut" [data]="chartDataDoughnut" [options]="doughnutOptions" width="270px" height="270px"></p-chart>
                  <div class="model-chart-legend">
                      <div *ngFor="let item of categoryTargetPercent" class="model-chart-legend-item">
                          <div class="model-chart-legend-color" [style.backgroundColor]="item.colorCode"></div>
                          <span>{{item.category}} ({{item.targetPercent}}%)</span>
                      </div>
                  </div>
              </div>
          </div>
      </div>
    </div>
</div>
